var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendDiferentMailIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.925293,
    width: 49,
    height: 49,
    rx: 24.5,
    stroke: "#ECECF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5228 16.3496H16.4772C15.3005 16.3496 14.3466 17.3654 14.3466 18.6185V32.2321C14.3466 33.4851 15.3005 34.501 16.4772 34.501H33.5228C34.6995 34.501 35.6535 33.4851 35.6535 32.2321V18.6185C35.6535 17.3654 34.6995 16.3496 33.5228 16.3496Z",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6535 19.7534L26.0973 26.2198C25.7684 26.4393 25.3881 26.5557 25 26.5557C24.6119 26.5557 24.2316 26.4393 23.9027 26.2198L14.3466 19.7534",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDiferentMailIcon);
export default __webpack_public_path__ + "static/media/sendDiferentMailIcon.6164dc1054264754963e8e8ded84bddd.svg";
export { ForwardRef as ReactComponent };